import { StudentProfileStatus, UserRole } from '@/enums/users';
import type { UserModelType } from '@/models/users';

export class PermissionsHelpers {
  static isActiveStudent = (user: UserModelType | null | undefined) => {
    return (
      user?.role === UserRole.STUDENT &&
      user?.studentprofile?.status === StudentProfileStatus.ACTIVE
    );
  };

  static isMentorOrAdmin = (user: UserModelType | null | undefined) => {
    return user?.role
      ? [UserRole.MENTOR, UserRole.ADMIN].includes(user.role)
      : false;
  };
}
